export function cn(...args) {
  return args.filter(Boolean).join(' ');
}

export function formatNumber(value, descimals) {
  if (descimals === undefined) descimals = 2;
  if (descimals === 0) {
    return Number(value)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, '$&\u00a0');
  } else {
    return Number(value)
      .toFixed(descimals)
      .replace(/\B(?=(\d{3})+(?!\d)\.)/g, '$&\u00a0')
      .replace('.', ',');
  }
}

const getNumberCategory = (val) => {
  if (val === 0) return 'zero';
  if (val === 1) return 'one';
  return 'other';
};

export const formatQuantity = (val, options) => {
  if (typeof val !== 'number' || !isFinite(val)) return '';
  let category = getNumberCategory(val, 0);
  if (!(`${category}Only` in options) && !(category in options)) {
    category = 'other';
  }
  if (`${category}Only` in options) {
    return options[`${category}Only`];
  }
  const formattedVal = formatNumber(val, 0);
  if (typeof options[category] === 'function') {
    return options[category](formattedVal);
  }
  return formattedVal + options[category];
};

export const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

export const slugify = (text) => {
  text = text.toString().toLowerCase().trim();

  const sets = [
    {to: 'a', from: '[ÀÁÂÃÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶÄ]'},
    {to: 'c', from: '[ÇĆĈČ]'},
    {to: 'd', from: '[ÐĎĐÞ]'},
    {to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
    {to: 'g', from: '[ĜĞĢǴ]'},
    {to: 'h', from: '[ĤḦ]'},
    {to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
    {to: 'j', from: '[Ĵ]'},
    {to: 'ij', from: '[Ĳ]'},
    {to: 'k', from: '[Ķ]'},
    {to: 'l', from: '[ĹĻĽŁ]'},
    {to: 'm', from: '[Ḿ]'},
    {to: 'n', from: '[ÑŃŅŇ]'},
    {to: 'o', from: '[ÒÓÔÕØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠŒÖ]'},
    {to: 'p', from: '[ṕ]'},
    {to: 'r', from: '[ŔŖŘ]'},
    {to: 's', from: '[ŚŜŞŠ]'},
    {to: 'ss', from: '[ß]'},
    {to: 't', from: '[ŢŤ]'},
    {to: 'u', from: '[ÙÚÛŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
    {to: 'ue', from: '[Ü]'},
    {to: 'w', from: '[ẂŴẀẄ]'},
    {to: 'x', from: '[ẍ]'},
    {to: 'y', from: '[ÝŶŸỲỴỶỸ]'},
    {to: 'z', from: '[ŹŻŽ]'},
    {to: '-', from: "[·/_,:;']"},
  ];

  sets.forEach((set) => {
    text = text.replace(new RegExp(set.from, 'gi'), set.to);
  });

  text = text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    // eslint-disable-next-line
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    // eslint-disable-next-line
    .replace(/\--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text

  text = text.replace(/-/g, '-');

  return text;
};
